import React from 'react';

export default function OrderHorizontalIcon({as = React.Fragment, Tag = as, ...props}) {
  return (
    <Tag {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="icon-order-horizontal"><path className="secondary" d="M18.59 17H9a1 1 0 0 1 0-2h9.59l-2.3-2.3a1 1 0 0 1 1.42-1.4l4 4a1 1 0 0 1 0 1.4l-4 4a1 1 0 0 1-1.42-1.4l2.3-2.3z"/><path className="primary" d="M5.41 7H15a1 1 0 0 1 0 2H5.41l2.3 2.3a1 1 0 0 1-1.42 1.4l-4-4a1 1 0 0 1 0-1.4l4-4a1 1 0 0 1 1.42 1.4L5.4 7z"/></svg>
    </Tag>
  )
};
